import { CircleCheckBig, ChartBar, MailCheck } from "lucide-react";
import { CategoryScale } from "chart.js";
import { Typography } from "@mui/material";

const query = new URLSearchParams(window.location.search);

const firstName = tmtAdminPortal.first_name;
const lastName = tmtAdminPortal.last_name;

export default function AdminPortal() {
  const isAdmin = !!tmtAdminPortal.is_admin;

  if (!isAdmin) {
    window.location.href = "portal-login";
  }

  return isAdmin ? (
    <div className="admin-portal-container">
      <div className="name-container">
        <Typography
          variant="h1"
          component="h1"
          sx={{ fontWeight: 600, fontSize: "4rem" }}
        >
          {`${lastName}, ${firstName}`}
        </Typography>
      </div>
      <div className="nav-page-bar-container">
        <NavPageBars title="Metrics" icon={ChartBar} link="event-metrics" />
        <NavPageBars
          title="Attendance Taker"
          icon={CircleCheckBig}
          link="attendance"
        />
        <NavPageBars title="Entries" icon={MailCheck} link="event-entries" />
      </div>
    </div>
  ) : (
    <></>
  );
}

function NavPageBars({ title, link = "", icon: Icon }) {
  const onClick = () => {
    window.location.href = link;
  };

  return (
    <div className="nav-page-bar" onClick={onClick}>
      <Icon size={32} />
      <Typography
        variant="h6"
        component="h6"
        sx={{ fontWeight: 600, fontSize: "1.5rem" }}
      >
        {title}
      </Typography>
    </div>
  );
}
